import {ChangeDetectorRef, Component, inject, Inject} from '@angular/core';
import {LoadingService} from "../../services/loading.service";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'loading-spinner',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss'
})
export class LoadingSpinnerComponent {

  cdr = inject(ChangeDetectorRef);
  loadingSubscriber: any;
  requestInProcess: number = 0;

  constructor(private _loading: LoadingService) {
    this.loadingSubscriber = this._loading._loadingSubscriber.subscribe((value) => {
      if (value === "SHOW") this.requestInProcess++;
      if (value === "HIDE" && this.requestInProcess > 0) this.requestInProcess--;
      this.cdr.markForCheck();
    })
  }

  ngOnDestroy(){
    this.loadingSubscriber.unsubscribe();
  }
}
